 
import React from "react";
import { PageLoader } from "../../../../../../components/PageLoader/PageLoader";
import { StandadCard } from "../../../../../../components/Cards";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { LoadState, MODULE_IDS } from "../../../../../../constants/enums";
import { useDispatchWrapper,
  useBreadcrumb,
} from "../../../../../../hooks";
import { useFormik } from "formik";
import { Box, Grid } from "@mui/material";
import {
  ControlledCustomSelect,
  CustomFormLabel,
  CustomTextField,
} from "../../../../../../components/formsComponents";
import { useNavigate, useParams } from "react-router-dom";
import { RoleBasedCustomButton } from "../../../../../../security/RoleBasedComponents/RoleBasedCustomButton/RoleBasedCustomButton";
import {
  addHabitationalConsentFormAsync,
  clearHabitationalPolicyForms,
  fetchHabitationalConsentFormAsync,
} from "../../../../../../redux/habitationalPolicy/HabitationalPolicyForm/HabitationalPolicyFormActions";
import { COMMON_STATUS } from "../../../../../../constants/constants";
import { useAppConfig } from "../../../../../../security/ApplicationProvider/ApplicationProvider";
import { PageContainer } from "../../../../../../components/container/PageContainer";
import { useCustomerPolicyDetails } from "../../../../../../hooks";
import { useHabitationalApplicationList } from "../hooks/useHabitationalApplicationList";

export const HabitationalConsentForm: React.FC<{ isDuplicate?: boolean }> = (
  props
) => {
  const { customerId, customerPolicyId, serialNumber } = useParams() as {
    customerId?: number;
    customerPolicyId?: number;
    serialNumber?: number;
  };

  useBreadcrumb({
    title: "",
    items: [
    {
      to: "/dashboard",
      title: "dashboard",
    },
    {
      to: "/view-customers",
      title: "customers",
    },
    {
      to: "/customer-overview/" + customerId,
      title: "customer-overview",
    },
    {
      title: "consent-form",
    },
  ],
  });


  const { isDuplicate } = props;

  React.useEffect(() => {
    return () => {
      dispatch(clearHabitationalPolicyForms());
    };
  }, []);

  const { data:consent, loading: consentLoading, error } = useSelector(
    (storeState: IStoreState) => storeState.habitational.policyform.consentform
  );
  const { details: policyAdmin } = useCustomerPolicyDetails(customerPolicyId);
  const { applicationDropdown, defaultApplicationNumber } = useHabitationalApplicationList(customerPolicyId);
  const [saveLoading, setSaveLoading] = React.useState(false);
  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();
  const {brokerPrivacyOfficer} = useAppConfig();
  const isUpdate = serialNumber ? true : false;
  const { values, handleChange, handleSubmit, setFieldValue, setValues } =
    useFormik({
      initialValues: consent,
      validate: (values) => {},
      onSubmit: (values) => {
        if (customerPolicyId && customerId) {
          setSaveLoading(true);
          dispatch(
            addHabitationalConsentFormAsync(
              {
                ...values,
                customer_id: customerId,
                customer_policy_id: customerPolicyId,
                producer_one_id: policyAdmin?.data?.producer_one,
                producer_one_code: policyAdmin?.data?.producer_one_code,
                application_number: values.application_number ? Number(values.application_number) : null,
              },
              consent,
              isUpdate,
              (isSuccess) => {
                if (isSuccess) {
                  window.scrollTo(0, 0);
                  navigate(
                    `/habitational-policy/${customerId}/policy-forms-tab/${customerPolicyId}?tab=2 `
                  );
                }
                setSaveLoading(false);
              },
              isDuplicate
            )
          );
        }
      },
    });

  React.useEffect(() => {
    if (customerPolicyId && serialNumber) {
      dispatch(
        fetchHabitationalConsentFormAsync(customerPolicyId, serialNumber)
      );
    }
  }, [customerPolicyId, serialNumber]);

  React.useEffect(() => {
    if (!serialNumber) {
      setValues({
        ...consent,
        customer_name: policyAdmin?.data?.customer_name,
        text_field: brokerPrivacyOfficer,
        producer_one_id: policyAdmin?.data?.producer_one,
        producer_one_code: policyAdmin?.data?.producer_one_code,
        application_number: defaultApplicationNumber,
        // policy_number: policyAdmin?.data?.policy_number,
      });
    } else {
      setValues(consent);
    }
  }, [consent, policyAdmin]);

  React.useEffect(() => {
    setFieldValue("customer_name", policyAdmin?.data?.customer_name);
    // setFieldValue("policy_number", policyAdmin?.data?.policy_number);
    // setFieldValue("policy_status", policyAdmin?.data?.policy_status);
  }, [policyAdmin]);

 

  return (
     <PageContainer
            title={
              serialNumber
                ? "Edit Consent Form"
                : "Create Consent Form"
            }
            description="Manage form ."
          >
    <PageLoader
      loading={consentLoading === LoadState.InProgress}
      error={error ? { message: error } : undefined}
    >
      <StandadCard sx={{ mt: 2 }} heading="Privacy Consent">
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <CustomFormLabel>Application Number</CustomFormLabel>
              <ControlledCustomSelect
                fullWidth
                value={values.application_number ?? ""}
                name="application_number"
                onChange={handleChange}
                placeholder="Select one"
                displayEmpty
                options={applicationDropdown}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomFormLabel>Customer Name</CustomFormLabel>
              <CustomTextField
                name="customer_name"
                variant="outlined"
                size="small"
                type="text"
                fullWidth
                disabled
                value={values.customer_name}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomFormLabel>Email Address</CustomFormLabel>
              <CustomTextField
                name="email_address"
                variant="outlined"
                size="small"
                type="text"
                fullWidth
                value={values.email_address}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomFormLabel>Broker's Privacy Officer</CustomFormLabel>
              <CustomTextField
                name="text_field"
                variant="outlined"
                size="small"
                type="text"
                fullWidth
                value={values.text_field}
                disabled
              />
            </Grid>
            <Grid item xs={12} lg={3}>
              <CustomFormLabel>Status</CustomFormLabel>
              <ControlledCustomSelect
                fullWidth
                value={values.status}
                name="status"
                onChange={handleChange}
                placeholder="Select one"
                displayEmpty
                options={COMMON_STATUS}
              ></ControlledCustomSelect>
            </Grid>
          </Grid>

          <Box sx={{ mt: 4 }}>
            <RoleBasedCustomButton
              sx={{ width: "15%" }}
              disabled={saveLoading}
              variant="contained"
              moduleKey={MODULE_IDS.COMMERCIAL_AUTO}
              type="submit"
            >
              Save
            </RoleBasedCustomButton>
          </Box>
        </form>
      </StandadCard>
      {/* </CustomerBaiscDetailsLayout> */}
    </PageLoader>
    </PageContainer>
  );
};
